export function percentFormatter(amountStr: string): string {
    if (!amountStr) return '';
    let formatted: string = amountStr?.replace('%', '');
    let amount: number = parseFloat(formatted) ? parseFloat(formatted) : 0; 
    if (amount <= 0) {
        formatted = '0';
    } else if (amount.toString().split('.')[1] && amount.toString().split('.')[1].length > 3) {
        formatted = amount.toFixed(3);
    } else {
        formatted = amount.toString();
    }
    return `${formatted}%`;
}